import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "components/Button/Button";
import { Loading } from "components/Loading/loading";
import { ModalForm } from "components/ModalForm/ModalForm";
import { Textbox } from "components/Textbox/Textbox";
import { Toast } from "components/ToastShow/ToastAlert";
import { UnitDictionary } from "pages/InventoryAndSales/Inventory/BaseDefinitionAndSetting/Unit/components/UnitDictionary";
import { useEffect, useRef, useState } from "react";
import { ICON_TYPE, INVENTORYANDSALES_URL } from "utils/constants";
import { FloorWithRoundingPlace, RoundWithRoundingPlace, trans, uuidv4 } from "utils/helpers";
import { getPriceListDetail } from "./api";
import { PriceDetails } from "../components/PriceDetails";
import { SalesOrderDetailType } from "./type";
import { ItemsForSell } from "../components/ItemsForSell/ItemsForSell";
import { WarehouseDictionaryWithAccess } from "../SalesInvoice/components/WarehouseDictionary/WarehouseDictionaryWithAccess";
import { DictionarySelectBox } from "components/DictionaryTypeSelect/DictionaryTypeSelect";
import { ENDPOINTSINVENTORYANDSALES } from "utils/endpoints";
import { MessageType } from "types/enum";
import { PriceInput } from "components/PriceInput/PriceInput";

interface SalesOrderFormProps {
  onHide: () => void;
  SalesOrderDetailCallBack?: (e: any) => void;
  selectedObj?: any;
  mode: any;
  priceList?: any;
  lastWarehouse?: any;
  OrderConstraint?: any;
  setLastWarehouse: (e: any) => void;
  salesWarehouse: any;
  personId?: any;
  currency?: any;
  salesOrderId?: any;
}

export const  SalesOrderDetailForm = ({
  lastWarehouse = null,
  OrderConstraint,
  setLastWarehouse,
  priceList,
  selectedObj,
  mode,
  onHide,
  SalesOrderDetailCallBack,
  salesWarehouse,
  personId,
  currency,
  salesOrderId,
}: SalesOrderFormProps) => {
  const [resetForm, setResetForm] = useState(false);
  const [loading, setLoading] = useState<any>(true);
  const [userChanges, setUserChanges] = useState({});
  const [showTree, setShowTree] = useState<any>();
  const [editedNewId,setEditedNewId]=useState<any>(false)//در مد ادیت اگر اتم عوض شود باید ایدی سطر را عوض کنیم که بک اند مشکل نخورد
  const [priceListDetail, setPriceListDetail] = useState<any>([]);
  const [detailPriceData, setDetailPriceData] = useState<any>({
    UnitPrice: 0,
    TotalPrice: 0,
    GrandTotalPrice: 0,
    Discount: 0,
    CustomerDiscount: 0,
    SubTotalPrice: 0,
    TaxRate: 0,
    Qty: mode != "create" ? selectedObj?.Qty : null,
  });
  const [itemData, setItemData] = useState<any>(null);
  const [dictionaryName, setDictionaryName] = useState<any>({});
  const [save_Exit, setSave_Exit] = useState<boolean>(false);
  const [showPriceListDetail, setShowPriceListDetail] = useState<any>(false);
  const [warehouseData, setWarehouseData] = useState<any>(lastWarehouse);
  const [itemSearch, setItemSearch] = useState<any>("");
  const formRef = useRef<any>();


  const handleSalesOrderFormSubmit = async (event) => {
    event.preventDefault();
   
    
    let data: SalesOrderDetailType = {
      Id: mode != "create" ?editedNewId?selectedObj?.Id+"changeId": selectedObj?.Id : uuidv4(),
      WarehouseId: warehouseData?.WarehouseId,
      WarehouseDetailId: warehouseData.WarehouseDetailId,
      Warehouse: warehouseData.WarehouseTitle,
      WarehouseDetail: warehouseData?.WarehouseDetail,
      SalesOrderId: salesOrderId,
      ItemId: itemData.ItemId,
      UnitId: event.target.UnitId.value == "" ? null : event.target.UnitId.value,
      SourceId: selectedObj?.SourceId,
      SourceData: selectedObj?.SourceData,
      Item: itemData.ItemDescription,
      ItemCode: itemData.Code,
      Qty: +event.target.Qty.value,
      UnitPrice: !OrderConstraint.IsFiscal
        ? undefined
        : +event.target.UnitPrice.value.replaceAll(",", ""),
      Unit: dictionaryName.Unit ? dictionaryName.Unit : null,
      TotalPrice: !OrderConstraint.IsFiscal
        ? undefined
        : 
        +event.target.TotalPrice.value.replaceAll(",", ""), //تخفیف کم میشود
        Discount: !OrderConstraint.IsFiscal
        ? undefined
        : +event.target.Discount.value.replaceAll(",", ""),
        CustomerDiscount: !OrderConstraint.IsFiscal
        ? undefined
        :event.target.CustomerDiscount? +event.target.CustomerDiscount?.value.replaceAll(",", ""):0,
        CustomerDiscountPercent: !OrderConstraint.IsFiscal
        ? undefined
        :event.target.CustomerDiscountPercent?.value?+event.target.CustomerDiscountPercent?.value :0,
        SubTotalPrice: !OrderConstraint.IsFiscal
        ? undefined
        : 
        +event.target.SubTotalPrice.value.replaceAll(",", ""),
        Description: event.target.Description.value,
        //      DescriptionEN: event.target.DescriptionEN.value,
        Tax:
        !OrderConstraint.IsFiscal || !OrderConstraint.HasTax
        ? 0
        : parseFloat(event.target.Tax.value.replace(/,/g, ""))
        ? parseFloat(event.target.Tax.value.replace(/,/g, ""))
          : 0,
          TaxRate:
          !OrderConstraint.IsFiscal || !OrderConstraint.HasTax
          ? 0
          : detailPriceData.TaxRate,
          DiscountPercent: !OrderConstraint.IsFiscal
          ? undefined
          : +event.target.DiscountPercent.value.replaceAll(",", ""),
          ItemTechnicalCode: event.target.ItemTechnicalCode?.value,
          QtyRoundingPlace:priceListDetail[0]?.Qty1RoundingPlace??selectedObj?.Qty1RoundingPlace,
          GrandTotalPrice: !OrderConstraint.IsFiscal
            ? 0
            :
  
            +event.target.GrandTotalPrice.value.replaceAll(",", ""), 
    };
    SalesOrderDetailCallBack?.(data) && resetFormIfNeeded();
  };

  const resetFormIfNeeded = () => {
    if (mode === "create") {
      setResetForm(true);
      setUserChanges({});
      setItemData(null);
      setDetailPriceData({
        TotalPrice: 0,
        GrandTotalPrice: 0,
        Discount: 0,
        CustomerDiscount: 0,
        SubTotalPrice: 0,
        Qty1: 1,
        Qty2: 1,
        TaxRate: 0,
      });
      setPriceListDetail([]);
    }
    sessionStorage.setItem("changingforms", "false");
    if (save_Exit) {
      onHide();
    }
  };

  const itemCodeHandeler = (obj, bool) => {
    if (obj.IsLeaf || bool) {
      // setLoading(false)
      setItemData({...obj,ItemId:obj.Id});
      getPriceListDetailAsync(obj.Id);
      setShowTree(false);
      //  setLoading(true)
      setShowPriceListDetail(true);

    } else {
      // Toast(trans("msg_itemleafisnotselected"), "error");
      Toast(trans("msg_itemleafisnotselected"), MessageType.error);

    }
  };

  function cancel() {
    if (sessionStorage.getItem("changingforms") + "" == "true") {
      // Toast(trans("modalclosemessage"), "warning", "alertWithoutClose", () => {
      //   sessionStorage.setItem("changingforms", "false");
      //   setUserChanges({});
      //   onHide();
      // });
      Toast(trans("modalclosemessage"),MessageType.confirm, () => {
        sessionStorage.setItem("changingforms", "false");
        setUserChanges({});
        onHide();
      });
    } else {
      onHide();
    }
  }

  const getPriceListDetailAsync = async (Id = null, Code = null,warehouseId=warehouseData.WarehouseId,warehouseDetailId=warehouseData.WarehouseDetailId) => {
    
    try {
      const res = await getPriceListDetail(
        Id,
       OrderConstraint.IsFiscal? priceList?.Id:null,
        Code,
        warehouseId,
        personId,
        warehouseDetailId=='noHaveWarehouseDetail'?undefined:warehouseDetailId,
        true
      );
      const newPriceListDetail=res.Data?.ItemPriceList.map((item)=>{
        return {...item,
          ItemId: res.Data.ItemId,
        MainUnitId: res.Data.MainUnitId,
        StatisticalUnitId: res.Data.StatisticalUnitId,
        PriceListUnitId: res.Data.PriceListUnitId,
        ItemDescription:res.Data.ItemDescription,
        ItemDescriptionEN: res.Data.ItemDescriptionEN,
        ItemCode: res.Data.ItemCode,
        ItemTechnicalCode: res.Data.ItemTechnicalCode,
        HasProductTracking: res.Data.HasProductTracking,
        HasExpireDate: res.Data.HasExpireDate,
        HasSerial: res.Data.HasSerial,
        IsAbsoluteUnitConversionRatio: res.Data.IsAbsoluteUnitConversionRatio,
        ConversionRatio: res.Data.ConversionRatio,
        PriceRoundingPlace: res.Data.PriceRoundingPlace,
        Qty1RoundingPlace: res.Data.Qty1RoundingPlace,
        Unit2: res.Data.Unit2,
        Unit2EN: res.Data.Unit2EN,
        Qty2RoundingPlace: res.Data.Qty2RoundingPlace,
ItemTaxList:res.Data.ItemTaxList,
ItemStockList:res.Data.ItemStockList,
          SalesUnitMaxOrderQty:item.SalesUnitId === item.MainUnitId?item.Unit1MaxOrderQty:item.Unit2MaxOrderQty,
          SalesUnitMinOrderQty:item.SalesUnitId === item.MainUnitId?item.Unit1MinOrderQty:item.Unit2MinOrderQty,
          SalesUnitPrice:item.SalesUnitId === item.MainUnitId?item.Unit1Price:item.Unit2Price,
          SalesUnitId:res.Data.SalesUnitId ,
          SalesUnitDiscount:res.Data.SalesUnitId === res.Data.MainUnitId?item.Unit1Discount:item.Unit2Discount,
          QtyRoundingPlace:res.Data.SalesUnitId === res.Data.MainUnitId?res.Data.Qty1RoundingPlace:res.Data.Qty2RoundingPlace,
        }    
      })
      if(res.Data.ItemId==selectedObj?.ItemId){
        setEditedNewId(true)
      }
      setPriceListDetail(!!newPriceListDetail.length?newPriceListDetail:[{
          ItemId: res.Data.ItemId,
        MainUnitId: res.Data.MainUnitId,
        StatisticalUnitId: res.Data.StatisticalUnitId,
        PriceListUnitId: res.Data.PriceListUnitId,
        ItemDescription:res.Data.ItemDescription,
        ItemDescriptionEN: res.Data.ItemDescriptionEN,
        ItemCode: res.Data.ItemCode,
         CustomerDiscountPercent:0,
        DiscountPercent:0,
        ItemTechnicalCode: res.Data.ItemTechnicalCode,
        HasProductTracking: res.Data.HasProductTracking,
        HasExpireDate: res.Data.HasExpireDate,
        HasSerial: res.Data.HasSerial,
        IsAbsoluteUnitConversionRatio: res.Data.IsAbsoluteUnitConversionRatio,
        ConversionRatio: res.Data.ConversionRatio,
        PriceRoundingPlace: res.Data.PriceRoundingPlace,
        Qty1RoundingPlace: res.Data.Qty1RoundingPlace,
        Unit2: res.Data.Unit2,
        Unit2EN: res.Data.Unit2EN,
        Qty2RoundingPlace: res.Data.Qty2RoundingPlace,
        ItemTaxList:res.Data.ItemTaxList,
          ItemStockList:res.Data.ItemStockList,
          SalesUnitMaxOrderQty:null,
          SalesUnitMinOrderQty:0,
          SalesUnitPrice:0,
          SalesUnitId:res.Data.SalesUnitId ,
          SalesUnitDiscount:0,
          QtyRoundingPlace:0,
          
      }]);
      
      setItemData({
        ...itemData,
        ItemDescription: res.Data.ItemDescription,
        ItemId: res.Data.ItemId,
        Code: res.Data.ItemCode,
      });
      if(priceList?.IsManual){//درصورتی که لیست قیمت دستی باشد چون مالیات را از استیت دیتیل پرایس دیتا میگیریم برای اینکه در مد ادیت مقدار مالیات را از دست ندهیم ، در صورتی که مد ادیت باشد یا ایجاد ابتدا مالیات را در این قسمت ست میکنیم که در توابع پایین تر بتواند محاسبات مالیات را انجام دهد.
        setDetailPriceData((prev)=>{return{
          ...prev,TaxRate:TaxHandler(res.Data.ItemTaxList)
        }})
      }
      if(!newPriceListDetail.length && !priceList.IsManual){
 Toast(trans("Msg_InvalidPriceListItem"), MessageType.error);
      }
      if (!OrderConstraint.IsFiscal)
        setDetailPriceData((pre) => {
          return { ...pre, UnitId: newPriceListDetail[0]?.SalesUnitId };
        });
    } catch {
      setItemSearch(Code);
      setShowTree(true);
    }
  };

  const changeQty = (newQty: any, PriceList = [], tax: any = null) => {
    
    let newDetailPriceData: any = null;
    if (
      priceList &&
      !priceList.IsManual &&
      !priceList.length &&
      !priceListDetail.length &&
      mode === "edit"
    ) {
      //این شرط برای اولین بار است که ادیت میزنیم و لیست قیمت نداریم پس باید لیست قیمت بگیریم و کلا از تابع بریم بیرون چون با ست شدن لیست قیمت دوباره وارد همین تابع میشیم
      setDetailPriceData((prev)=>{return{ ...prev, Qty:RoundWithRoundingPlace(newQty,selectedObj.QtyRoundingPlace)  }}); //برای وقتی که مود ادیت هست و برای بار اول به تعداد یکی اضافه میکنیم چون این تابع ریترن داره و مقدار با عدد جدید ست نمیشه اینجا ست میکنیم.
      getPriceListDetailAsync(detailPriceData.ItemId);
      return null; // to not go continue function beacuse this function set priceListDetail to causes to run useEffect and run changeQty
    }
    if(priceList?.HasDetailRange &&
      priceListDetail[priceListDetail.length - 1]
      ?.SalesUnitMaxOrderQty+1 === detailPriceData.Qty && priceListDetail[priceListDetail.length - 1]
      ?.SalesUnitMaxOrderQty!==null){
        // در لیست قیمت بازه ای اگر  مود ادیت است و اولین بار هست که قراره به مقدار یکی اضافه بشه باید تشخیص بدهیم مقدار جدید از ماکسیمم لیست قیمت بیشتر نشود
        newQty=newQty-1
      }

    if (priceList && !priceList.IsManual && OrderConstraint.IsFiscal ) {

      if(!!PriceList?.length || !!priceListDetail?.length) {
 [...(priceList.length > 0 && priceList?.[0]?.SalesUnitPrice? PriceList : priceListDetail)].map((e) => {
        if (
          (+e.SalesUnitMaxOrderQty >= newQty || e.MaxOrderQty == null) &&
          +e.SalesUnitMinOrderQty <= newQty
        ) {
          newDetailPriceData = e;
        }
      });
      }
      else{
          newDetailPriceData = {
        SalesUnitPrice: 0,     
        DiscountPercent:0
      };
      }
     
    } else {
      newDetailPriceData =
        (priceList && priceList.length) > 0 ? PriceList[0] : priceListDetail[0];
      newDetailPriceData = {
        ...detailPriceData,
        ...newDetailPriceData,
        SalesUnitPrice: detailPriceData.UnitPrice
          ? detailPriceData.UnitPrice
          : 0,
        DiscountPercent: detailPriceData?.DiscountPercent
          ? detailPriceData?.DiscountPercent
          : 0,
      };
    }

    const totalTaxRate = priceList?.IsManual
      ? detailPriceData.TaxRate
      : TaxHandler(priceListDetail?.[0]?.ItemTaxList);



    setDetailPriceData((pre) => {
     
        let totalPrice = 0;
   
        const discount=RoundWithRoundingPlace(
          (+newQty *
            (+newDetailPriceData?.SalesUnitPrice *
              (+newDetailPriceData?.DiscountPercent))) /
            100,
          currency?.PriceRoundingPlace,
          
        );

        const customerDiscount=RoundWithRoundingPlace(
        (+newQty * (+newDetailPriceData?.SalesUnitPrice * ((100-newDetailPriceData?.DiscountPercent)/100)) *(newDetailPriceData?.CustomerDiscountPercent/100)),
        currency?.PriceRoundingPlace,
        
      );
      if(newDetailPriceData?.CustomerDiscountPercent && newDetailPriceData?.CustomerDiscountPercent !=0 ){
       const totalDiscount=discount+customerDiscount

        totalPrice =    RoundWithRoundingPlace(
          (+newQty *+newDetailPriceData?.SalesUnitPrice ) -totalDiscount ,
          currency?.PriceRoundingPlace,
          
        );

      }else{
        totalPrice =    RoundWithRoundingPlace(
          (+newQty *+newDetailPriceData?.SalesUnitPrice ) -discount ,
          currency?.PriceRoundingPlace,
          
        );
      }




      return {
        TotalPrice:newDetailPriceData?.SalesUnitPrice==-1?0:totalPrice,
        Discount: discount,
        CustomerDiscount: customerDiscount,
        CustomerDiscountPercent:newDetailPriceData?.CustomerDiscountPercent,
        SubTotalPrice:newDetailPriceData?.SalesUnitPrice==-1?0: +newQty * +newDetailPriceData?.SalesUnitPrice,
        GrandTotalPrice:newDetailPriceData?.SalesUnitPrice==-1?0:   totalPrice + ((((OrderConstraint.HasTax  && mode!='view') || mode=='view') ? totalTaxRate : 0) *  +totalPrice) / 100 ,
        Qty:
          ((+newDetailPriceData?.SalesUnitMaxOrderQty >= newQty ||newDetailPriceData?.SalesUnitMaxOrderQty==null)  &&
            +newDetailPriceData?.SalesUnitMinOrderQty <= newQty) ||
          (priceList && priceList.IsManual)
            ?RoundWithRoundingPlace(newQty,priceListDetail[0]?.QtyRoundingPlace??selectedObj?.QtyRoundingPlace,) 
            : RoundWithRoundingPlace(pre.Qty,priceListDetail[0]?.QtyRoundingPlace??selectedObj?.QtyRoundingPlace,) ,
        ItemTechnicalCode: newDetailPriceData?.ItemTechnicalCode,
        MaxOrderQty: newDetailPriceData?.SalesUnitMaxOrderQty,
        MinOrderQty: newDetailPriceData?.SalesUnitMinOrderQty,
        QtyMainUnit: newDetailPriceData?.QtyMainUnit,
        QtyStatisticalUnit: newDetailPriceData?.QtyStatisticalUnit,
        IsAbsoluteUnitConversionRatio:
          newDetailPriceData?.IsAbsoluteUnitConversionRatio,
        PriceListId: newDetailPriceData?.PriceListId,
        UnitDiscount: newDetailPriceData?.SalesUnitDiscount,
        UnitId:
          newDetailPriceData?.SalesUnitId ,
        UnitPrice: newDetailPriceData?.SalesUnitPrice,
        TaxRate: (OrderConstraint.HasTax  && mode!='view') || mode=='view' ? totalTaxRate : 0,
        DiscountPercent: +newDetailPriceData?.DiscountPercent.toString().slice(
          0,
          5
        ),
      };
    });
  };
  const TaxHandler = (list) => {
    //  const res = await getTaxList(Id);
    let totalTaxRate = 0;
    if (!!list?.length) {
      list?.map((item) => {
        totalTaxRate += item.TaxRate;
      });
      return totalTaxRate;
    } else {
      return 0;
    }
  };

  const handleBeforeUnload = (event) => {
    event.preventDefault();
    event.returnValue = "";
  };
  const initializeFormWithSelectedObject = () => {
    setItemData({
      ...selectedObj,
      Code: selectedObj.ItemCode,
      ItemDescription: selectedObj.Item,
      ItemId:selectedObj.ItemId
    });
 
    setDetailPriceData({
      ...selectedObj,
      TaxRate: (OrderConstraint.HasTax  && mode!='view') || mode=='view' ? selectedObj.TaxRate : 0,
      SalesUnitMaxOrderQty:null,
      SalesUnitMinOrderQty:1,
      MaxOrderQty:null,
      MinOrderQty:1,
      SalesUnitPrice:selectedObj.SalesUnitId === selectedObj.Unit1Id?selectedObj.Unit1Price:selectedObj.Unit2Price,
      SalesUnitId:selectedObj.SalesUnitId === selectedObj.Unit1Id?selectedObj.Unit1Id:selectedObj.Unit2Id,
      SalesUnitDiscount:selectedObj.Discount,
      CustomerDiscount:selectedObj.CustomerDiscount,
      CustomerDiscountPercent:selectedObj.CustomerDiscountPercent,
    });
  };

  useEffect(() => {
    if (selectedObj?.Id && mode !== "create") {
      initializeFormWithSelectedObject();
    }
  }, []);
  useEffect(() => {
    if (Object.values(userChanges).filter((item) => item != null).length > 0) {
      sessionStorage.setItem("changingforms", "true");
      window.addEventListener("beforeunload", handleBeforeUnload);
      return () => {
        window.removeEventListener("beforeunload", handleBeforeUnload);
      };
    } else {
      sessionStorage.setItem("changingforms", "false");
      window.removeEventListener("beforeunload", handleBeforeUnload);
    }
  }, [userChanges]);

  useEffect(() => {
    if (resetForm) {
      setResetForm(false);
    }
  }, [resetForm]);

  useEffect(() => {
    if (mode == "edit" && !!priceListDetail.length) {     
      changeQty(
        (selectedObj.ItemId == itemData.ItemId) && (selectedObj?.WarehouseId == warehouseData?.WarehouseId) && (selectedObj?.WarehouseDetailId == warehouseData?.WarehouseDetailId)
          ? detailPriceData.Qty
          : priceListDetail[0]?.SalesUnitMinOrderQty?priceListDetail[0]?.SalesUnitMinOrderQty:1,
        priceListDetail
      );
    }
    if (mode == "create" && !!priceListDetail.length) {
      changeQty(
        priceListDetail[0]?.SalesUnitMinOrderQty
          ? priceListDetail[0]?.SalesUnitMinOrderQty:
           1,
        priceListDetail
      );
    }
  }, [priceListDetail]);




  return (
    <div className="card " style={{ flexDirection: "row" }}>
      {showTree && (
        <ModalForm
          mode={mode}
          title="ItemTree"
          onHide={() => setShowTree(false)}
          show={showTree}
        >
          <ItemsForSell
            priceListId={priceList?.Id}
            warehouseId={warehouseData?.WarehouseId}
            searchString={itemSearch}
            warehouseDetailId={warehouseData?.WarehouseDetailId ?? null}
            onHide={() => {
              setShowTree(false);
            }}
            itemCodeHandeler={itemCodeHandeler}
            isFiscal={OrderConstraint.IsFiscal}
          />
        </ModalForm>
      )}

      <div style={{ flexWrap: "nowrap" }} className="card-body row">
        <div
          className={`card-body ${
            !!priceListDetail.length
              ? "col-12 col-md-7 col-lg-8 col-xl-9"
              : "col-12"
          }`}
        >
          {loading ? (
            <div className="container-fluid">
              <form ref={formRef} onSubmit={handleSalesOrderFormSubmit}>
                <div className="row">
                  <div className="col-lg-2 col-11">
                {(selectedObj?.WarehouseId || mode=='create') &&    <WarehouseDictionaryWithAccess
                      name="Warehouse"
                      label="Warehouse"
                      resetForm={resetForm}
                      value={mode != "create" ? selectedObj?.WarehouseId : null}
                      onChange={(e, obj) => {
                        setWarehouseData({
                       // ...(warehouseData? warehouseData:{}),
                          WarehouseId: e,
                          WarehouseTitle: obj?.Name?.Description,
                          WarehouseDetailsCount:
                          obj?.Name?.WarehouseDetailsCount,
                          WarehouseDetailId: obj?.Name?.WarehouseDetailsCount>0 ?warehouseData?.WarehouseDetailId?warehouseData?.WarehouseDetailId:null:null
                        });
                        if (e !== selectedObj?.WarehouseId) {
                          setUserChanges({});
                          // setItemData(null);
                          setDetailPriceData({
                            TotalPrice: 0,
                            GrandTotalPrice: 0,
                            Discount: 0,
                            CustomerDiscount: 0,
                            SubTotalPrice: 0,
                            Qty1: 1,
                            Qty2: 1,
                            TaxRate: 0,
                          });
                          setPriceListDetail([]);
                          //چون استیت انبار در این مرحله هنوز اپدیت نشده و دیتای قبلی وارد تابع میشه پس درصورتی که انبار فرعی ندارد با مقدار رشته 
                          //noHaveWarehouseDetail 
                          // //انبار فرعی را پر میکنیم تا توی تشخیص بدیم که انبار فرعی ندارد
                        (itemData?.ItemId &&obj?.Name?.WarehouseDetailsCount ==0) &&  getPriceListDetailAsync(itemData?.ItemId,null,e,'noHaveWarehouseDetail')
                        }
                      }}
                      mode={mode}
                      required={true}
                    />}
                  </div>

                  {(warehouseData?.WarehouseDetailsCount > 0 ||
                    warehouseData?.WarehouseDetailId) && (
                    <div className="col-lg-2 col-11">
                      <DictionarySelectBox
                        name="WarehouseDetail"
                        label="WarehouseDetail"
                        params={{ warehouseId: warehouseData?.WarehouseId }}
                        onChange={(e, obj) => {
                          if(e !== selectedObj?.WarehouseDetailId){
                            //  setItemData(null);
              setUserChanges({});
              setDetailPriceData({
          TotalPrice: 0,
                            GrandTotalPrice: 0,
                            Discount: 0,
                            CustomerDiscount: 0,
                            SubTotalPrice: 0,
                            Qty1: 1,
                            Qty2: 1,
                            TaxRate: 0,
              });
               itemData?.ItemId &&  getPriceListDetailAsync(itemData?.ItemId,null,warehouseData?.WarehouseId,e)
                          }

                          setWarehouseData((prev) => {
                            return {
                              ...prev,
                              WarehouseDetailId: e,
                              WarehouseDetail: obj?.Name,
                            };
                          });
                        }}
                        baseUrl={INVENTORYANDSALES_URL}
                        endPoint={
                          ENDPOINTSINVENTORYANDSALES.Inventory
                            .BaseInformationApi.WarehouseDetail.dictionary
                        }
                        value={
                          mode != "create" ? selectedObj?.WarehouseDetailId : null
                        }
                        resetForm={resetForm}
                        mode={mode}
                      />
                    </div>
                  )}

                  <div
                    className="col-lg-2 col-sm-12"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      flexDirection: "row",
                    }}
                  >
                    <Textbox
                      required
                      onBlurHandler={(e) => {
                        if (e && e != itemData?.Code && !showTree) {
                          getPriceListDetailAsync(null, e);
                        }
                      }}
                      Change={(e) => {
                        setUserChanges({ ...userChanges, ...e });
                      }}
                      onChange={(e) => {
                        if (e.target.value === null || e.target.value === "") {
                          setDetailPriceData({
                            TotalPrice: 0,
                            GrandTotalPrice: 0,
                            Discount: 0,
                            CustomerDiscount: 0,
                            SubTotalPrice: 0,
                            Qty: 1,
                            TaxRate:0
                          });
                          setItemData({});
                          setItemSearch("");
                        } else {
                          if (
                            // e.target.value != itemData?.Code &&
                            e.target.value.length > 2 )
                         if(isNaN(e.target.value) )    {
                           
                           setShowTree(true);
                         }
                            setItemSearch(e.target.value);
                        }
                      }}
                      textboxName={"itemCode"}
                      textboxType="text"
                      resetForm={resetForm}
                      labelText={"itemCode"}
                      mode={mode}
                      value={itemData?.Code}
                      defaultValue={itemData?.Code}
                    />
                    {mode != "view" && (
                      <div style={{ marginTop: "4px", width: "10%" }}>
                        <Button
                          Icon={true}
                          value={
                            <button
                              onClick={(e) => setShowTree(true)}
                              type="button"
                              className="checkButton d-flex align-items-center justify-content-center"
                            >
                              {" "}
                              <FontAwesomeIcon
                                icon={[ICON_TYPE, "diagram-project"]}
                                size="1x"
                              />
                            </button>
                          }
                          btnType="primary"
                          onClick={(e) => setShowTree(true)}
                        />
                      </div>
                    )}
                  </div>

                  {itemData && itemData?.ItemDescription && (
                    <div className="col-lg-4">
                      <Textbox
                        Change={(e) => {
                          setUserChanges({ ...userChanges, ...e });
                        }}
                        withChangeDir={true}
                        textboxName="ItemDescription"
                        textboxType="text"
                        labelText="itemDescription"
                        value={itemData?.ItemDescription}
                        defaultValue={itemData?.ItemDescription}
                        resetForm={resetForm}
                        mode={"view"}
                        required={false}
                      />
                    </div>
                  )}

                  <div className="col-lg-2">
                    <Textbox
                      Change={(e) => {
                        setUserChanges({ ...userChanges, ...e });
                      }}
                      textboxName="ItemTechnicalCode"
                      textboxType="text"
                      labelText="TechnicalCode"
                      value={detailPriceData.ItemTechnicalCode + ""}
                      defaultValue={
                        detailPriceData?.ItemTechnicalCode
                          ? detailPriceData.ItemTechnicalCode
                          : null
                      }
                      resetForm={resetForm}
                      mode="view"
                      required={false}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-3">
                    <Textbox
                      Change={(e) => {
                        setUserChanges({ ...userChanges, ...e });
                      }}
                      textboxName="Qty"
                      textboxType="number"
                      labelText="Qty"
                      customClass={"arrow-none"}
                      step={10 **(priceListDetail[0]?.QtyRoundingPlace??selectedObj?.QtyRoundingPlace)}
                      value={
                        detailPriceData?.Qty
                          ? detailPriceData.Qty
                          : !!priceListDetail.length &&
                            priceListDetail[0]?.SalesUnitMinOrderQty
                          ? priceListDetail[0]?.SalesUnitMinOrderQty:
                         1 + ""
                      }
                      defaultValue={
                        detailPriceData?.Qty
                          ? detailPriceData.Qty
                          : !!priceListDetail.length &&
                            priceListDetail[0]?.SalesUnitMinOrderQty
                          ? priceListDetail[0]?.SalesUnitMinOrderQty:
                      
                           1+'' + ""
                      }
                      usePrevDefaultValue={
                        priceList?.HasDetailRange &&
                        priceListDetail[priceListDetail.length - 1]
                          ?.SalesUnitMaxOrderQty+1 === detailPriceData.Qty
                      }
                      min={
                        priceListDetail.length > 0
                          ? priceListDetail[0]?.SalesUnitMinOrderQty
                            ? priceListDetail[0]?.SalesUnitMinOrderQty
                            :10** (priceListDetail[0]?.QtyRoundingPlace??selectedObj?.QtyRoundingPlace)

                          :10** (priceListDetail[0]?.QtyRoundingPlace??selectedObj?.QtyRoundingPlace)

                      }
                      max={
                        priceListDetail.length > 0
                          ? priceListDetail[priceListDetail.length - 1]
                              ?.SalesUnitMaxOrderQty
                          : undefined
                      }
                      decimals={priceListDetail[0]?.Unit1RoundingPlace}
                      resetForm={resetForm}
                      mode={mode}
                      required={true}
                      onChange={(e) => {
                        changeQty(+e.target.value);
                      }}
                    />
                  </div>
                  <div className="col-lg-3">
                    <UnitDictionary
                    returnObj
                      Change={(e) => {
                        setUserChanges({ ...userChanges, ...e });
                      }}
                      value={detailPriceData.UnitId}
                      label="Unit"
                      name="UnitId"
                      required={false}
                      mode={"view"}
                      resetForm={resetForm}
                      setUnitDictionary={(e) => {
                        setDictionaryName({ ...dictionaryName, Unit: e.Value });
                      }}
                    />
                  </div>
                  {OrderConstraint?.IsFiscal && (
                    <>
                      <div className="col-lg-3">
                        {/* <Textbox
                          Change={(e) => {
                            setUserChanges({ ...userChanges, ...e });
                          }}
                          textboxName="UnitPrice"
                          textboxType="text"
                          labelText="UnitPrice"
                          value={
                            detailPriceData?.UnitPrice
                              ? detailPriceData.UnitPrice + ""
                              : 0
                          }
                          decimals={currency?.PriceRoundingPlace}
                          round={false}
                          defaultValue={
                            detailPriceData?.UnitPrice
                              ? detailPriceData.UnitPrice + ""
                              : "0"
                          }
                          resetForm={resetForm}
                          mode={
                            priceList?.IsManual && mode != "view"
                              ? "create"
                              : "view"
                          }
                          useGroupingPrice={true}
                          onChange={(e) => {
                            if (priceList?.IsManual) {
                              setDetailPriceData((pre) => {
                                return {
                                  ...pre,
                                  UnitPrice: +e.target.value.replaceAll(
                                    ",",
                                    ""
                                  ),
                                  SubTotalPrice:
                                    +e.target.value.replaceAll(",", "") *
                                    pre.Qty,
                                    TotalPrice: RoundWithRoundingPlace(
                                    (+detailPriceData.Qty *
                                      (+e.target.value.replaceAll(",", "") *
                                        (100 -
                                          (detailPriceData.DiscountPercent
                                            ? +detailPriceData.DiscountPercent
                                            : 0)))) /
                                      100,
                                    currency?.PriceRoundingPlace,
                                    
                                  ),
                                };
                              });
                            } else {
                              setDetailPriceData((pre) => {
                                return {
                                  ...pre,
                                  UnitPrice: +e.target.value.replaceAll(
                                    ",",
                                    ""
                                  ),
                                  SubTotalPrice:
                                    +e.target.value.replaceAll(",", "") *
                                    pre.Qty,
                                };
                              });
                            }
                          }}
                          required={false}
                        /> */}
                        <PriceInput
                          Change={(e) => {
                            setUserChanges({ ...userChanges, ...e });
                          }}
                          name="UnitPrice"
                          label="UnitPrice"
                          value={
                            detailPriceData?.UnitPrice
                              ? detailPriceData.UnitPrice + ""
                              : 0
                          }
                          useCallForPrice={ detailPriceData?.UnitPrice==-1?true:false}
                          CallForPriceText={OrderConstraint?.ItemNoPriceText}
                          decimals={currency?.PriceRoundingPlace}
                          round={false}
                          defaultValue={
                            detailPriceData?.UnitPrice
                              ? detailPriceData.UnitPrice + ""
                              : "0"
                          }
                          resetForm={resetForm}
                          mode={
                            priceList?.IsManual && mode != "view"
                              ? "create"
                              : "view"
                          }
                          onChange={(e) => {
                            if (priceList?.IsManual) {
                              setDetailPriceData((pre) => {
                                return {
                                  ...pre,
                                  UnitPrice: +e.target.value.replaceAll(
                                    ",",
                                    ""
                                  ),
                                  Discount:(+e.target.value.replaceAll(",", "") *
                                    pre.Qty * detailPriceData.DiscountPercent)/100,
                                  SubTotalPrice:
                                    +e.target.value.replaceAll(",", "") *
                                    pre.Qty,
                                    TotalPrice: RoundWithRoundingPlace(
                                    (+detailPriceData.Qty *
                                      (+e.target.value.replaceAll(",", "") *
                                        (100 -
                                          (detailPriceData.DiscountPercent
                                            ? +detailPriceData.DiscountPercent
                                            : 0)))) /
                                      100,
                                    currency?.PriceRoundingPlace,
                                    
                                  ),
                                  GrandTotalPrice:(RoundWithRoundingPlace(
                                    (+detailPriceData.Qty *
                                      (+e.target.value.replaceAll(",", "") *
                                        (100 -
                                          (detailPriceData.DiscountPercent
                                            ? +detailPriceData.DiscountPercent
                                            : 0)))) /
                                      100,
                                    currency?.PriceRoundingPlace,
                                    
                                  )) + ((((OrderConstraint.HasTax  && mode!='view') || mode=='view') ? detailPriceData?.TaxRate : 0) *  +(RoundWithRoundingPlace(
                                    (+detailPriceData.Qty *
                                      (+e.target.value.replaceAll(",", "") *
                                        (100 -
                                          (detailPriceData.DiscountPercent
                                            ? +detailPriceData.DiscountPercent
                                            : 0)))) /
                                      100,
                                    currency?.PriceRoundingPlace,
                                    
                                  ))) / 100
                                };
                              });
                            } else {
                              setDetailPriceData((pre) => {
                                return {
                                  ...pre,
                                  UnitPrice: +e.target.value.replaceAll(
                                    ",",
                                    ""
                                  ),
                                  SubTotalPrice:
                                    +e.target.value.replaceAll(",", "") *
                                    pre.Qty,
                                };
                              });
                            }
                          }}
                          required={false}
                        
                        />
                      </div>
                      <div className="col-lg-3">
                        {/* <Textbox
                          Change={(e) => {
                            setUserChanges({ ...userChanges, ...e });
                          }}
                          textboxName="SubTotalPrice"
                          textboxType="text"
                          labelText="مبلغ"
                          value={
                            detailPriceData?.SubTotalPrice
                              ? detailPriceData.SubTotalPrice
                              : 0
                          }
                          decimals={currency?.PriceRoundingPlace}
                          round={false}
                          defaultValue={
                            detailPriceData?.SubTotalPrice
                              ? detailPriceData.SubTotalPrice + ""
                              : "0"
                          }
                          resetForm={resetForm}
                          mode={
                            priceList?.IsManual && mode != "view"
                              ? "create"
                              : "view"
                          }
                          useGroupingPrice={true}
                          required={false}
                        /> */}
                        <PriceInput
                         Change={(e) => {
                            setUserChanges({ ...userChanges, ...e });
                          }}
                          name="SubTotalPrice"
                          label="مبلغ"
                          value={
                            detailPriceData?.SubTotalPrice
                              ? detailPriceData.SubTotalPrice
                              : 0
                          }
                          decimals={currency?.PriceRoundingPlace}
                          round={false}
                          defaultValue={
                            detailPriceData?.SubTotalPrice
                              ? detailPriceData.SubTotalPrice + ""
                              : "0"
                          }
                          resetForm={resetForm}
                          mode={
                          "view"
                          }
                          required={false}
                        />
                      </div>
                    </>
                  )}
                </div>
                {OrderConstraint?.IsFiscal && (
                  <>
                    <div className="row justify-content-end">
                      <div className="col-lg-2">
                        <Textbox
                          Change={(e) => {
                            setUserChanges({ ...userChanges, ...e });
                          }}
                          textboxName="DiscountPercent"
                          textboxType="number"
                          customClass={'arrow-none'}
                          useTrans={false}
                      labelText={trans("DiscountPercent")+'%'}
                          value={detailPriceData?.DiscountPercent + ""}
                          onChange={(e) =>
                            setDetailPriceData((pre) => {
                              return {
                                ...pre,
                                DiscountPercent: +e.target.value,
                                Discount:
                                  (+e.target.value * pre.SubTotalPrice) / 100,
                                  TotalPrice:
                                  pre.SubTotalPrice -
                                  (+e.target.value * pre.SubTotalPrice) / 100,
Tax:(pre.SubTotalPrice -
                                  (+e.target.value * pre.SubTotalPrice) / 100
                             *detailPriceData?.TaxRate)/100,
GrandTotalPrice:(pre.SubTotalPrice -
                                  (+e.target.value * pre.SubTotalPrice) / 100) + ((((OrderConstraint.HasTax  && mode!='view') || mode=='view') ? detailPriceData?.TaxRate : 0) *  +(pre.SubTotalPrice -
                                  (+e.target.value * pre.SubTotalPrice) / 100)) / 100

                              };
                            })
                          }
                          usePrevDefaultValue={detailPriceData?.DiscountPercent==100}
                          max={100}
                          min={0}
                          defaultValue={
                            detailPriceData?.DiscountPercent
                              ? detailPriceData.DiscountPercent + ""
                              : detailPriceData?.DiscountPercent == 0
                              ? "0"
                              : ""
                          }
                          resetForm={resetForm}
                          mode={
                            priceList?.IsManual && mode != "view"
                              ? "create"
                              : "view"
                          }
                          required={false}
                        />
                      </div>
                      <div className="col-lg-3">
                        {/* <Textbox
                          Change={(e) => {
                            setUserChanges({ ...userChanges, ...e });
                          }}
                          textboxName="Discount"
                          textboxType="text"
                          labelText="Discount"
                          value={RoundWithRoundingPlace(
                            detailPriceData?.Discount,
                            currency?.PriceRoundingPlace,
                            
                          )}
                          defaultValue={
                            detailPriceData?.Discount
                              ? RoundWithRoundingPlace(
                                  detailPriceData?.Discount,
                                  currency?.PriceRoundingPlace,
                                  
                                ) + ""
                              : detailPriceData?.Discount == 0
                              ? "0"
                              : ""
                          }
                          resetForm={resetForm}
                          decimals={currency?.PriceRoundingPlace}
                          round={false}
                          onChange={(e) => {
                            setDetailPriceData({
                              ...detailPriceData,
                              TotalPrice:
                                detailPriceData.SubTotalPrice -
                                +e.target.value.replaceAll(",", ""),
                              UnitDiscount: +e.target.value.replaceAll(",", ""),
                              DiscountPercent: +(
                                (+e.target.value.replaceAll(",", "") /
                                  detailPriceData.SubTotalPrice) *
                                100
                              )
                                .toString()
                                .slice(0, 5),
                            });
                          }}

                          mode={
                            priceList?.IsManual && mode != "view"
                              ? "create"
                              : "view"
                          }
                          useGroupingPrice={true}
                          required={false}
                        /> */}
                        <PriceInput
                           Change={(e) => {
                            setUserChanges({ ...userChanges, ...e });
                          }}
                         name="Discount"
                        label="Discount"
                          value={RoundWithRoundingPlace(
                            detailPriceData?.Discount,
                            currency?.PriceRoundingPlace,
                            
                          )}
                          defaultValue={
                            detailPriceData?.Discount
                              ? RoundWithRoundingPlace(
                                  detailPriceData?.Discount,
                                  currency?.PriceRoundingPlace,
                                  
                                ) + ""
                              : detailPriceData?.Discount == 0
                              ? "0"
                              : ""
                          }
                          resetForm={resetForm}
                          decimals={currency?.PriceRoundingPlace}
                          round={false}
                          onChange={(e) => {
                            setDetailPriceData({
                              ...detailPriceData,
                              TotalPrice:
                                detailPriceData.SubTotalPrice -
                                +e.target.value.replaceAll(",", ""),
                              UnitDiscount: +e.target.value.replaceAll(",", ""),
                              DiscountPercent: +(
                                (+e.target.value.replaceAll(",", "") /
                                  detailPriceData.SubTotalPrice) *
                                100
                              )
                                .toString()
                                .slice(0, 5),
Tax:(detailPriceData.SubTotalPrice -
                                +e.target.value.replaceAll(",", "")
                             *detailPriceData?.TaxRate)/100,

GrandTotalPrice:(detailPriceData.SubTotalPrice -
                                +e.target.value.replaceAll(",", "")) + (((OrderConstraint.HasTax  && mode!='view') || mode=='view' ? detailPriceData?.TaxRate : 0) *  +(detailPriceData.SubTotalPrice -
                                +e.target.value.replaceAll(",", ""))) / 100

                            });
                          }}

                          mode={
                            priceList?.IsManual && mode != "view"
                              ? "create"
                              : "view"
                          }
                          required={false}
                        
                        />
                      </div>
                      {(detailPriceData?.CustomerDiscountPercent &&detailPriceData.CustomerDiscountPercent !=0 )?
                      <div className="row justify-content-end">
                       
                      <div className="col-lg-3">
                        {/* <Textbox
                          Change={(e) => {
                            setUserChanges({ ...userChanges, ...e });
                          }}
                          textboxName="Price2"
                          textboxType="text"
                          labelText="totalprice"
                          value={
                            detailPriceData.SubTotalPrice*(100-detailPriceData?.DiscountPercent)/100
                          }
                          defaultValue={detailPriceData.SubTotalPrice*(100-detailPriceData?.DiscountPercent)/100
                          }
                          resetForm={resetForm}
                          decimals={currency?.PriceRoundingPlace}
                          round={false}
                          mode={ "view"   }
                          useGroupingPrice={true}

                        /> */}
                        <PriceInput
                          Change={(e) => {
                            setUserChanges({ ...userChanges, ...e });
                          }}
                          name="Price2"
                          label="totalprice"
                          value={
                            detailPriceData.SubTotalPrice*(100-detailPriceData?.DiscountPercent)/100
                          }
                          defaultValue={detailPriceData.SubTotalPrice*(100-detailPriceData?.DiscountPercent)/100
                          }
                          resetForm={resetForm}
                          decimals={currency?.PriceRoundingPlace}
                          round={false}
                          mode={ "view"   }
                        />
                      </div>
                      <div className="w-100"></div>
                        <div className="col-lg-2">
                        <Textbox
                          Change={(e) => {
                            setUserChanges({ ...userChanges, ...e });
                          }}
                          textboxName="CustomerDiscountPercent"
                          textboxType="number"
                          customClass={'arrow-none'}
                          useTrans={false}
                          labelText={trans("CustomerDiscountPercent")+'%'}
                          value={detailPriceData?.CustomerDiscountPercent + ""}
                          max={100}
                          min={0}
                          defaultValue={
                            detailPriceData?.CustomerDiscountPercent
                              ? detailPriceData.CustomerDiscountPercent + ""
                              : detailPriceData?.CustomerDiscountPercent == 0
                              ? "0"
                              : ""
                          }
                          resetForm={resetForm}
                          mode={ "view"}
                        />
                      </div>
                      <div className="col-lg-3">
                        {/* <Textbox
                          Change={(e) => {
                            setUserChanges({ ...userChanges, ...e });
                          }}
                          textboxName="CustomerDiscount"
                          textboxType="text"
                          labelText="CustomerDiscount" 
                          value={detailPriceData.CustomerDiscount}
                          defaultValue={detailPriceData.CustomerDiscount+''}
                          resetForm={resetForm}
                          decimals={currency?.PriceRoundingPlace}
                          round={false}
                          mode={"view" }
                          useGroupingPrice={true}
                        /> */}
                        <PriceInput
                         Change={(e) => {
                            setUserChanges({ ...userChanges, ...e });
                          }}
                          name="CustomerDiscount"
                          label="CustomerDiscount" 
                          value={detailPriceData.CustomerDiscount}
                          defaultValue={detailPriceData.CustomerDiscount+''}
                          resetForm={resetForm}
                          decimals={currency?.PriceRoundingPlace}
                          round={false}
                          mode={"view" }
                        />
                      </div>
                      </div>:''
                      }



                      <div className="w-100"></div>
                      <div className="col-lg-3">
                        {/* <Textbox
                          Change={(e) => {
                            setUserChanges({ ...userChanges, ...e });
                          }}
                          textboxName="TotalPrice"
                          textboxType="text"
                          labelText="totalprice"
                          value={
                            detailPriceData.TotalPrice
                              ? detailPriceData.TotalPrice + ""
                              : 0
                          }
                          defaultValue={
                            detailPriceData?.TotalPrice
                              ? detailPriceData?.TotalPrice + ""
                              : "0"
                          }
                          resetForm={resetForm}
                          decimals={currency?.PriceRoundingPlace}
                          round={false}
                          mode={
                            priceList?.IsManual && mode != "view"
                              ? "create"
                              : "view"
                          }
                          useGroupingPrice={true}
                          required={false}
                        /> */}
                        <PriceInput
                             Change={(e) => {
                            setUserChanges({ ...userChanges, ...e });
                          }}
                          name="TotalPrice"
                          label="totalprice"
                          value={
                            detailPriceData.TotalPrice
                              ? detailPriceData.TotalPrice + ""
                              : 0
                          }
                          defaultValue={
                            detailPriceData?.TotalPrice
                              ? detailPriceData?.TotalPrice + ""
                              : "0"
                          }
                          resetForm={resetForm}
                          decimals={currency?.PriceRoundingPlace}
                          round={false}
                          mode={
                           "view"
                          }
                          required={false}
                        
                        />
                      </div>
                    </div>
                 { ((mode!='view' && OrderConstraint.HasTax) || mode=='view' )&&   <div className="row justify-content-end">
                        <div className="col-lg-2">
                        <Textbox
                          Change={(e) => {
                            setUserChanges({ ...userChanges, ...e });
                          }}
                          textboxName="TaxRate"
                          textboxType="number"
                          customClass={'arrow-none'}
                          useTrans={false}
                          labelText={trans('TaxRate')+'%'}
                          defaultValue={
                            ((OrderConstraint.HasTax  && mode!='view') || mode=='view') &&   detailPriceData?.TaxRate?detailPriceData?.TaxRate
                            + ""
                              : "0"
                          }
                          value={
                           ( (OrderConstraint.HasTax  && mode!='view') || mode=='view') &&   detailPriceData?.TaxRate?detailPriceData?.TaxRate
                            + ""
                              : "0"
                          }
                          mode={
                            "view"
                          }
                          required={false}
                        />
                      </div>
                      <div className="col-lg-3">
                        {/* <Textbox
                          useGroupingPrice
                          Change={(e) => {
                            setUserChanges({ ...userChanges, ...e });
                          }}
                          textboxName="Tax"
                          textboxType="text"
                          labelText="Tax"
                          decimals={currency?.PriceRoundingPlace}
                          round={OrderConstraint.FloorTaxDuty}
                          defaultValue={
                            (OrderConstraint.HasTax  && mode!='view') || mode=='view'&&
                            detailPriceData?.TaxRate
                              ?OrderConstraint?.FloorTaxDuty?FloorWithRoundingPlace(
                                (+detailPriceData.TaxRate *
                                  +detailPriceData.TotalPrice) /
                                  100,
                                currency?.PriceRoundingPlace,
                                
                              ) + "": RoundWithRoundingPlace(
                                  (+detailPriceData.TaxRate *
                                    +detailPriceData.TotalPrice) /
                                    100,
                                  currency?.PriceRoundingPlace,
                                  
                                ) + ""
                              : "0"
                          }
                          value={
                            OrderConstraint.HasTax && detailPriceData?.TaxRate
                              ?OrderConstraint?.FloorTaxDuty?FloorWithRoundingPlace(
                                (+detailPriceData.TaxRate *
                                  +detailPriceData.TotalPrice) /
                                  100,
                                currency?.PriceRoundingPlace,
                                
                              ) + "": RoundWithRoundingPlace(
                                  (+detailPriceData.TaxRate *
                                    +detailPriceData.TotalPrice) /
                                    100,
                                  currency?.PriceRoundingPlace,
                                  
                                ) + ""
                              : "0"
                          }
                          resetForm={resetForm}
                          mode={'view'
                          }
                          required={false}
                          // onChange={(e) => {
                          //   if (priceList?.IsManual) {
                          //     setDetailPriceData({
                          //       ...detailPriceData,
                          //       TaxRate:
                          //         (+e.target.value.replaceAll(",", "") * 100) /
                          //         detailPriceData.TotalPrice,
                          //     });
                          //   }
                          // }}
                        /> */}
                        <PriceInput
                          Change={(e) => {
                            setUserChanges({ ...userChanges, ...e });
                          }}
                          name="Tax"
                          label="Tax"
                          decimals={currency?.PriceRoundingPlace}
                          round={OrderConstraint.FloorTaxDuty}
                          defaultValue={
                           ((mode!='view' && OrderConstraint.HasTax) || mode=='view' )  &&
                            detailPriceData?.TaxRate
                              ?OrderConstraint?.FloorTaxDuty?FloorWithRoundingPlace(
                                (+detailPriceData.TaxRate *
                                  +detailPriceData.TotalPrice) /
                                  100,
                                currency?.PriceRoundingPlace,
                                
                              ) + "": RoundWithRoundingPlace(
                                  (+detailPriceData.TaxRate *
                                    +detailPriceData.TotalPrice) /
                                    100,
                                  currency?.PriceRoundingPlace,
                                  
                                ) + ""
                              : "0"
                          }
                          value={
                            ((mode!='view' && OrderConstraint.HasTax) || mode=='view' ) && detailPriceData?.TaxRate
                              ?OrderConstraint?.FloorTaxDuty?FloorWithRoundingPlace(
                                (+detailPriceData.TaxRate *
                                  +detailPriceData.TotalPrice) /
                                  100,
                                currency?.PriceRoundingPlace,
                                
                              ) + "": RoundWithRoundingPlace(
                                  (+detailPriceData.TaxRate *
                                    +detailPriceData.TotalPrice) /
                                    100,
                                  currency?.PriceRoundingPlace,
                                  
                                ) + ""
                              : "0"
                          }
                          resetForm={resetForm}
                          mode={'view'
                          }
                          required={false}
                        
                        />
                      </div>
                    </div>}
                    <div className="row justify-content-end">
                      <div className="col-lg-3">
                        {/* <Textbox
                          Change={(e) => {
                            setUserChanges({ ...userChanges, ...e });
                          }}
                          textboxName="GrandTotalPrice"
                          textboxType="text"
                          labelText="payableamount"
                          value={ detailPriceData?.GrandTotalPrice?detailPriceData?.GrandTotalPrice    : "0"}
                          defaultValue={detailPriceData?.GrandTotalPrice?detailPriceData?.GrandTotalPrice    : "0"  }
                          resetForm={resetForm}
                          decimals={currency?.PriceRoundingPlace}
                          round={false}
                          mode={
                            priceList?.IsManual && mode != "view"
                              ? "create"
                              : "view"
                          }
                          useGroupingPrice={true}
                          required={false}
                        /> */}
                        <PriceInput
                             Change={(e) => {
                            setUserChanges({ ...userChanges, ...e });
                          }}
                          name="GrandTotalPrice"
                          label="payableamount"
                          value={ detailPriceData?.GrandTotalPrice?detailPriceData?.GrandTotalPrice    : "0"}
                          defaultValue={detailPriceData?.GrandTotalPrice?detailPriceData?.GrandTotalPrice+''    : "0"  }
                          resetForm={resetForm}
                          decimals={currency?.PriceRoundingPlace}
                          round={false}
                          mode={
                            "view"
                          }
                          required={false}
                        />
                      </div>
                    </div>
                  </>
                )}
                <div className="col-12">
                  <Textbox
                    Change={(e) => {
                      setUserChanges({ ...userChanges, ...e });
                    }}
                    textboxType="textarea"
                    textboxName="Description"
                    labelText="Description"
                    defaultValue={
                      mode != "create" ? selectedObj?.Description : null
                    }
                    resetForm={resetForm}
                    mode={mode}
                    required={false}
                    maxLength={150}
                    letterCounter={true}
                  />
                </div>

                <>
                  {mode != "view" ? (
                    <div className="col-lg-12 mt-1 btns_form">
                      {mode === "create" && (
                        <Button value="save" btnType="submit" />
                      )}
                      <Button
                        value="SaveAndClose"
                        btnType="submit"
                        onClick={() => {
                          setSave_Exit(true);
                        }}
                      />
                      <Button
                        btnType="cancel"
                        value="Cancel"
                        onClick={() => {
                          cancel();
                        }}
                      />
                    </div>
                  ) : (
                    <div className="col-lg-12 mt-1 btns_form">
                      <Button
                        btnType="primary"
                        value="close"
                        onClick={() => {
                          cancel();
                        }}
                      />
                    </div>
                  )}
                </>
              </form>
            </div>
          ) : (
            <Loading />
          )}
        </div>
        {!!priceListDetail.length &&
          priceList?.HasDetailRange &&
          (mode === "create" || (mode === "edit" && showPriceListDetail)) && (
            <PriceDetails constraint={OrderConstraint} priceListDetail={priceListDetail} />
          )}
      </div>
    </div>
  );
};
